module.exports = __webpack_public_path__ + "static/img/weather62.b59eddfc.png";